import { HttpHeaders } from '@angular/common/http';
import { AddToCartProductStockUnavailable } from '@scalefast/core';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import CartResponseProcessor from '../../../Shared/Infrastructure/Http/CartResponsePipeProcessor';
import CART_EXCEPTIONS from '../Exceptions/CartExceptionMap';
const ENDPOINT_TAXES = '/taxes';
class XAPICartRepository {
  constructor(context, checkoutConfig, httpClient) {
    this.context = context;
    this.checkoutConfig = checkoutConfig;
    this.httpClient = httpClient;
    this.url = `${this.checkoutConfig.xApi.cartUrl}`;
  }
  getCart(data) {
    const {
      cartToken,
      cartProvider
    } = data;
    this.url = `${this.url}/${cartProvider}/${cartToken}/cart`;
    const header = new HttpHeaders({
      'x-api-key': this.checkoutConfig.xApi.xApiKey
    });
    const requestOptions = {
      headers: header
    };
    return this.httpClient.get(this.url, requestOptions).pipe(CartResponseProcessor.handle(CART_EXCEPTIONS), map(response => response));
  }
  setCart(data) {
    const {
      products,
      cartToken,
      cartProvider
    } = data;
    this.url = `${this.url}/${cartProvider}/${cartToken}/cart`;
    const options = {
      headers: {
        'x-api-key': this.checkoutConfig.xApi.xApiKey
      }
    };
    return this.httpClient.put(this.url, {
      products
    }, options).pipe(CartResponseProcessor.handle(CART_EXCEPTIONS), map(response => response));
  }
  addToCart(data) {
    const {
      products,
      product,
      cartToken,
      cartProvider
    } = data;
    let newCart = [];
    if (!products || !products.length) {
      newCart = [product];
    }
    const productIndex = products.findIndex(item => item.productId === product.productId);
    if (productIndex >= 0) {
      const newQuantity = products[productIndex].quantity + product.quantity;
      product.quantity = newQuantity;
      if (!product.stock) {
        return throwError(new AddToCartProductStockUnavailable('There is not enough stock for this product'));
      }
      if (newQuantity > data.maxItemQuantity) {
        products[productIndex].quantity = data.maxItemQuantity;
      } else {
        products[productIndex] = product;
      }
    } else {
      products.push(product);
    }
    newCart = products;
    return this.setCart({
      products: newCart,
      cartToken,
      cartProvider
    });
  }
  updateCart(data) {
    const {
      products,
      product,
      cartToken,
      cartProvider
    } = data;
    let newCart = [];
    const productIndex = products.findIndex(item => item.productId === product.productId);
    if (productIndex >= 0) {
      products[productIndex] = product;
    }
    newCart = products;
    return this.setCart({
      products: newCart,
      cartToken,
      cartProvider
    });
  }
  removeFromCart(data) {
    const {
      products,
      productId,
      cartToken,
      cartProvider
    } = data;
    let newCart = [];
    newCart = products.filter(item => item.productId !== productId);
    return this.setCart({
      products: newCart,
      cartToken,
      cartProvider
    });
  }
  deleteCart(data) {
    const {
      cartToken,
      cartProvider
    } = data;
    this.url = `${this.url}/${cartProvider}/${cartToken}/cart`;
    const options = {
      headers: {
        'x-api-key': this.checkoutConfig.xApi.xApiKey
      }
    };
    return this.httpClient.delete(this.url, options).pipe(CartResponseProcessor.handle(CART_EXCEPTIONS), map(response => response));
  }
  getTaxes(data) {
    const accessToken = data.accessToken;
    const taxesRequest = data.taxesRequest;
    const url = `${this.context.baseUrl}${ENDPOINT_TAXES}`;
    const body = JSON.stringify(taxesRequest);
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json'
    });
    return this.httpClient.post(url, body, {
      headers
    }).pipe(data => data);
  }
}

export { XAPICartRepository as default };